'use client';

import { atom } from 'jotai';

export const scrollToFinanceAtom = atom<boolean>(false);
